import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  desktopDevice: true,
  largeDesktopDevice: false,
};

const desktopBreakpoint = 1350;

const resizeWindowSlice = createSlice({
  name: 'resizeWindow',
  initialState,
  reducers: {
    setDesktopDevice(state, { payload }) {
      state.desktopDevice = desktopBreakpoint < payload;
    },
  },
})

export const { setDesktopDevice } = resizeWindowSlice.actions;

export default resizeWindowSlice.reducer;
